import "./utils";
import "./components/layout/header";

import("./components/layout/smooth-scroll").catch((error) => {
  console.error("Failed to load SmoothScroll module:", error);
});

if (document.querySelector("[data-scroll-top]")) {
  import("./components/layout/scroll-to-top").catch((error) => {
    console.error("Failed to load ScrollToTop module:", error);
  });
}

if (document.querySelector(".swiper")) {
  import("./swipers/main").catch((error) => {
    console.error("Failed to load Swiper module:", error);
  });
}

if (document.querySelector("[data-created-slider]")) {
  import("./components/home/created").catch((error) => {
    console.error("Failed to load Created slider module:", error);
  });
}

if (document.querySelector("[data-roadmap]")) {
  import("./components/home/roadmap").catch((error) => {
    console.error("Failed to load Roadmap module:", error);
  });
}

if (document.querySelector(".article-single")) {
  import("./components/article/single").catch((error) => {
    console.error("Failed to load Article module:", error);
  });
}

if (document.querySelector(".backdrop")) {
  import("./popups/main").catch((error) => {
    console.error("Failed to load Popups module:", error);
  });
}

import "../css/main.scss";
